/** vendor */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

/** lib */
import Loading from '../UI/Loading'

export default function NotesList({ notes, onSelectNote }) {

    const [loading, setLoading] = useState(false)

    /**
     * Handlers
     */
    const handleOnSelectNote = (note) => {
        onSelectNote(note)
    }

    if(loading) {
        return (<div className="h-[60vh] relative pt-40"><Loading /></div>)
    }

    return (
        <div className="w-full">
            { 
                notes &&
                    <>
                        {
                            notes.map((note, index) => (
                                <div key={index} className="w-full py-3 px-2 cursor-pointer odd:bg-an_white-dark hover:bg-an_white-darker1">
                                    <div className="flex-1 cursor-pointer" 
                                        onClick={() => { handleOnSelectNote(note) }}
                                    >    
                                        <div className="pb-2 ">
                                            <small className="text-xs block">{note.date}</small>
                                            <small className="text-lg block">{ note.title }</small>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </>        
            }

            { 
                notes?.length < 1 &&
                    <p className="text-center pt-40">zip.</p>

            }
        </div>
    )
}
